import { createSlice } from '@reduxjs/toolkit';
import { GetShipmentState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getShipmentThunk } from './thunks';

// Initial State
const initialState: GetShipmentState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const getShipmentSlice = createSlice({
  name: 'listShipments',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getShipmentThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getShipmentThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(getShipmentThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset, setValues } = getShipmentSlice.actions;
export * from './thunks';
export * from './selectors';
export default getShipmentSlice.reducer;
